import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import searchIcon from "../../../assets/images/search-icon.svg";
import filterIcon from "../../../assets/images/filter-icon.svg";

import styles from "./TableOptions.scss";

class TableOptions extends Component {
  render() {
    return (
      <div>
        <div className={styles.tableOptionsContainer}>
          <div className={styles.tableOptions}>
            <div className={styles.textContainer}>
              <div>{this.props.title}</div>
            </div>
            <div className={styles.rightContainer}>
              <div className={styles.rowsNumber}>
                {this.props.paginationCount}
              </div>
              <div className={styles.verticalDivider} />
              {this.props.onSearchClick && (
                <img
                  src={searchIcon}
                  className={
                    this.props.searchsNumber > 0
                      ? styles.searchIcon
                      : styles.icon
                  }
                  onClick={this.props.onSearchClick}
                />
              )}
              {this.props.searchsNumber > 0 && (
                <div
                  className={classNames({
                    [styles.numberCircle]: true,
                    [styles.searchLabel]: true
                  })}
                >
                  {this.props.searchsNumber}
                </div>
              )}
              {this.props.onFilterClick && (
                <img
                  src={filterIcon}
                  onClick={this.props.onFilterClick}
                  className={classNames({
                    [styles.filterIcon]: true,
                    [styles.iconLast]: this.props.filtersNumber <= 0
                  })}
                />
              )}
              {this.props.filtersNumber > 0 && (
                <div className={styles.numberCircle}>
                  {this.props.filtersNumber}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

TableOptions.propTypes = {
  title: PropTypes.string.isRequired,
  paginationCount: PropTypes.string.isRequired,
  onSettingsClick: PropTypes.func,
  onSearchClick: PropTypes.func,
  onFilterClick: PropTypes.func,
  tableColumns: PropTypes.array.isRequired
};

TableOptions.defaultProps = {
  title: "",
  paginationCount: "",
  sortable: true,
  filterable: true
};

export default TableOptions;



// WEBPACK FOOTER //
// ./src/components/common/table/TableOptions.js